webpackJsonp([3],{

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__brightspark_sparkling_ajax_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__brightspark_sparkling_ajax_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__brightspark_sparkling_ajax_js__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var GallerySlider = /** @class */ (function (_super) {
    __extends(GallerySlider, _super);
    function GallerySlider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GallerySlider.prototype.data = function () {
        this._cols = this.model.columnAmount;
        //this.$set(this, 'cols', this.model.columnAmount);
        return {
            currentSlideNo: 1,
            dataUrl: this.model.dataUrl,
            filter: this.model.filter,
            groups: this.model.groups,
            isDataRequestInProgress: false
        };
    };
    GallerySlider.prototype.mounted = function () {
        window.addEventListener('resize', this.handleResize);
    };
    GallerySlider.prototype.beforeDestroy = function () {
        window.removeEventListener('resize', this.handleResize);
    };
    GallerySlider.prototype.handleResize = function () {
        var newAmount = this.getColumnAmount();
        if (this._cols !== newAmount) {
            this.$set(this, 'cols', newAmount);
        }
    };
    GallerySlider.prototype.next = function () {
        this.slideForward();
    };
    GallerySlider.prototype.slideForward = function () {
        var _this = this;
        if (this._data.isDataRequestInProgress || !this._data.filter) {
            return;
        }
        this._data.isDataRequestInProgress = true;
        __WEBPACK_IMPORTED_MODULE_1__brightspark_sparkling_ajax_js__(this._data.dataUrl, { dataType: "json", method: "post", data: this._data.filter })
            .done(function (model) {
            if (!model) {
                return;
            }
            for (var i = 0; i < model.groups.length; i++) {
                _this.model.groups.push(model.groups[i]);
            }
            _this._data.filter = model.filter;
            _this._data.isDataRequestInProgress = false;
        });
    };
    GallerySlider.prototype.showLightbox = function (images) {
        this.$parent.$emit('show-lightbox', 0, images);
    };
    GallerySlider.prototype.getColumnAmount = function () {
        var screenSize = {
            mobileSmall: 650,
            mobile: 767,
            tablet: 1023
        };
        var articlesPerSlide = this.model.columnAmount;
        var currentWindowWidth = window.innerWidth;
        if (currentWindowWidth < screenSize.tablet) {
            articlesPerSlide = 2;
        }
        if (currentWindowWidth < screenSize.mobile) {
            articlesPerSlide = 2;
        }
        if (currentWindowWidth < screenSize.mobileSmall) {
            articlesPerSlide = 1;
        }
        return articlesPerSlide;
    };
    GallerySlider.prototype.getGalleries = function () {
        var res = [];
        for (var i = 0; i < this.model.groups.length; i++) {
            res.push({
                title: this.model.groups[i].title,
                galleryGroups: this.divideByCols(i)
            });
        }
        return res;
    };
    GallerySlider.prototype.divideByCols = function (index) {
        var articlesPerSlide = this.getColumnAmount();
        var res = [];
        var galleryGroup = this._data.groups[index].galleryGroups;
        for (var row = 0; row < articlesPerSlide; row++) {
            var col = [];
            res.push(col);
            for (var i = row; i < galleryGroup.length; i += articlesPerSlide) {
                col.push(galleryGroup[i]);
            }
        }
        return res;
    };
    Object.defineProperty(GallerySlider.prototype, "galleries", {
        get: function () {
            // hack to make it reactive
            var colAmount = this._cols;
            var res = [];
            for (var i = 0; i < this.model.groups.length; i++) {
                res.push({
                    title: this.model.groups[i].title,
                    galleryGroups: this.divideByCols(i)
                });
            }
            return res;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GallerySlider.prototype, "nextButtonClass", {
        get: function () {
            var classList = ["button", "button--secondary-down", "button--tiny"];
            if (!this._data.filter) {
                classList.push("button--disabled");
            }
            return classList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GallerySlider.prototype, "imgRowClass", {
        get: function () {
            var classList = ["table__row"];
            classList.push("table__row--col" + this._cols);
            return classList;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], GallerySlider.prototype, "model", void 0);
    GallerySlider = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], GallerySlider);
    return GallerySlider;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (GallerySlider);


/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_touch_events__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_touch_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_touch_events__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"].use(__WEBPACK_IMPORTED_MODULE_1_vue2_touch_events___default.a);
var Lightbox = /** @class */ (function (_super) {
    __extends(Lightbox, _super);
    function Lightbox() {
        var _this = _super.call(this) || this;
        _this._items = [];
        _this.src = '';
        _this.current = 0;
        _this.show = false;
        _this.navPrevDisabled = false;
        _this.navNextDisabled = false;
        return _this;
    }
    Lightbox.prototype.mounted = function () {
        this.$parent.$on('show-lightbox', this.Open);
        this.$parent.$on('show-lightbox-single', this.OpenSingle);
    };
    Lightbox.prototype.Open = function (current, items) {
        this._items = items;
        this.current = current;
        this.ShowItem();
        this.show = true;
    };
    Lightbox.prototype.OpenSingle = function (url) {
        this._items = [{
                url: url,
                thumb: '',
                type: 'image'
            }];
        this.current = 0;
        this.ShowItem();
        this.show = true;
    };
    Lightbox.prototype.Hide = function () {
        this.show = false;
    };
    Lightbox.prototype.ShowItem = function () {
        var item = this._items[this.current];
        this.src = item.url;
        if (item.imageSize) {
            this.height = item.imageSize.height;
            this.width = item.imageSize.width;
        }
        this.navPrevDisabled = this.current < 1;
        this.navNextDisabled = this.current > this._items.length - 2;
    };
    Lightbox.prototype.Previous = function () {
        if (this.navPrevDisabled) {
            return;
        }
        this.current--;
        this.ShowItem();
    };
    Lightbox.prototype.Next = function () {
        if (this.navNextDisabled) {
            return;
        }
        this.current++;
        this.ShowItem();
    };
    Lightbox = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], Lightbox);
    return Lightbox;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (Lightbox);


/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core_Factories_ViewFactory__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Gallery_GalleryIndexView__ = __webpack_require__(525);


__WEBPACK_IMPORTED_MODULE_0__Core_Factories_ViewFactory__["a" /* ViewFactory */].setRegistry({
    'GalleryIndexView': __WEBPACK_IMPORTED_MODULE_1__Gallery_GalleryIndexView__["a" /* GalleryIndexView */],
});


/***/ }),

/***/ 525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GalleryIndexView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_GallerySlider_GallerySlider_vue__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Lightbox_Lightbox_vue__ = __webpack_require__(528);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var GalleryIndexView = /** @class */ (function (_super) {
    __extends(GalleryIndexView, _super);
    function GalleryIndexView() {
        var _this = _super.call(this) || this;
        _this.SetupVue();
        return _this;
    }
    GalleryIndexView.prototype.SetupVue = function () {
        var v = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
            el: ".app",
            data: {},
            components: {
                GallerySlider: __WEBPACK_IMPORTED_MODULE_2__Components_GallerySlider_GallerySlider_vue__["a" /* default */],
                Lightbox: __WEBPACK_IMPORTED_MODULE_3__Components_Lightbox_Lightbox_vue__["a" /* default */]
            }
        });
    };
    return GalleryIndexView;
}(__WEBPACK_IMPORTED_MODULE_0__Core__["b" /* View */]));



/***/ }),

/***/ 526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_GallerySlider_ts__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75fd2818_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GallerySlider_vue__ = __webpack_require__(527);
var disposed = false
var normalizeComponent = __webpack_require__(27)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_GallerySlider_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75fd2818_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GallerySlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "www\\js\\Components\\GallerySlider\\GallerySlider.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-75fd2818", Component.options)
  } else {
    hotAPI.reload("data-v-75fd2818", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table" },
    [
      _vm._l(_vm.galleries, function(galleryGroup, index) {
        return _vm.model.groups && _vm.model.groups.length
          ? _c("div", [
              _c("h2", [_vm._v(_vm._s(galleryGroup.title))]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "table__column" }, [
                  _c(
                    "div",
                    { staticClass: "table--monthly" },
                    _vm._l(galleryGroup.galleryGroups, function(column) {
                      return _c(
                        "div",
                        { class: _vm.imgRowClass },
                        _vm._l(column, function(item) {
                          return _c("div", { staticClass: "table__column" }, [
                            !item.imgUrl
                              ? _c("div", { staticClass: "blog__img" })
                              : _vm._e(),
                            _vm._v(" "),
                            item.imgUrl
                              ? _c("img", {
                                  staticClass: "blog__img",
                                  attrs: { src: item.imgUrl }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "gallery__img-hover" }, [
                              _c("h3", [_vm._v(_vm._s(item.title))]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "gallery__img-hover__footer" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button button--secondary",
                                      on: {
                                        click: function($event) {
                                          _vm.showLightbox(item.images)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        VAATA KÕIKI PILTE\n                                    "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        })
                      )
                    })
                  )
                ])
              ])
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      !_vm.model.groups || (_vm.model.groups && !_vm.model.groups.length)
        ? _c("div", { staticClass: "row" }, [
            _c("h3", [_vm._v("Otsingule vastavaid pilte ei leitud ")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row pagination__container" }, [
        _c("div", [
          _c(
            "button",
            {
              class: _vm.nextButtonClass,
              attrs: { type: "button" },
              on: { click: _vm.next }
            },
            [_vm._v("\n                LAE VANEMAID PILTE\n            ")]
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75fd2818", esExports)
  }
}

/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_Lightbox_ts__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f199026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lightbox_vue__ = __webpack_require__(530);
var disposed = false
var normalizeComponent = __webpack_require__(27)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_Lightbox_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f199026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "www\\js\\Components\\Lightbox\\Lightbox.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2f199026", Component.options)
  } else {
    hotAPI.reload("data-v-2f199026", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { staticClass: "lightbox" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "touch",
                rawName: "v-touch:swipe.left",
                value: _vm.Next,
                expression: "Next",
                arg: "swipe",
                modifiers: { left: true }
              },
              {
                name: "touch",
                rawName: "v-touch:swipe.right",
                value: _vm.Previous,
                expression: "Previous",
                arg: "swipe",
                modifiers: { right: true }
              }
            ],
            staticClass: "lightbox__content"
          },
          [
            _c("div", {
              staticClass: "lightbox__content__image",
              style: {
                "background-image": "url(" + _vm.src + ")",
                "max-height": _vm.height + "px",
                "max-width": _vm.width + "px"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "lightbox__nav lightbox__nav--close",
            on: { click: _vm.Hide }
          },
          [
            _c("span", { staticClass: "icon" }, [
              _c("svg", [
                _c("use", {
                  attrs: {
                    "xlink:href": "/images/icons/symbol-defs.svg#icon-close"
                  }
                })
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "lightbox__nav lightbox__nav--prev",
            class: { disabled: _vm.navPrevDisabled },
            on: { click: _vm.Previous }
          },
          [
            _c("span", { staticClass: "icon" }, [
              _c("svg", [
                _c("use", {
                  attrs: {
                    "xlink:href":
                      "/images/icons/symbol-defs.svg#icon-arrow-next"
                  }
                })
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "lightbox__nav lightbox__nav--next",
            class: { disabled: _vm.navNextDisabled },
            on: { click: _vm.Next }
          },
          [
            _c("span", { staticClass: "icon" }, [
              _c("svg", [
                _c("use", {
                  attrs: {
                    "xlink:href":
                      "/images/icons/symbol-defs.svg#icon-arrow-next"
                  }
                })
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f199026", esExports)
  }
}

/***/ })

},[524]);


// WEBPACK FOOTER //
// js/page/media.bundle.js